export const currency = window.__litium.culture.currency || 'SEK';